<div class="setting-page">
  <legend>LDAP Authentication Server</legend>
  <arm-form (submitForm)="submit()" [disableSubmit]="!canSubmit">
    <div class="ldap-authentication-settings">
      <div class="form-table-column">

        <arm-form-title>LDAP Authentication Server</arm-form-title>
        <div class="settings-section">
          <mat-slide-toggle color="primary"
                            [checked]="ldapAuthentication.isEnabled"
                            (change)="ldapAuthentication.isEnabled = $event.checked">
            Enable LDAP Authentication
          </mat-slide-toggle>

          <mat-form-field class="fullWidth">
            <mat-label>Server Host</mat-label>
            <input [(ngModel)]="ldapAuthentication.host" matInput name="host" [required]="ldapAuthentication.isEnabled">
          </mat-form-field>

          <mat-form-field class="port fullWidth">
            <mat-label>Server Port</mat-label>
            <input [(ngModel)]="ldapAuthentication.port" matInput min="1"
                   max="65535" name="port" type="number" [required]="ldapAuthentication.isEnabled">
          </mat-form-field>

          <mat-form-field class="fullWidth">
            <mat-label>LDAP Connectivity DN</mat-label>
            <input [(ngModel)]="ldapAuthentication.dn" matInput name="dn" [required]="ldapAuthentication.isEnabled">
          </mat-form-field>

          <mat-form-field class="fullWidth">
            <mat-label>LDAP Connectivity Password</mat-label>
            <input [(ngModel)]="ldapAuthentication.password" matInput name="password" type="password">
          </mat-form-field>

          <mat-form-field class="fullWidth">
            <mat-label>User Dn Search Base</mat-label>
            <textarea matInput [(ngModel)]="ldapAuthentication.baseObject" name="baseObject"></textarea>
          </mat-form-field>

          <mat-form-field class="fullWidth">
            <mat-label>Connect timeout (Seconds):</mat-label>
            <input [(ngModel)]="ldapAuthentication.connectTimeout" matInput min="1" max="30" name="connect-timeout" type="number">
          </mat-form-field>

          <div class="server-test-connectivity-result-wrapper" [ngClass]="{'green': testResultServer === 'Ldap server connection test successful'}">
            <span class="server-test-connectivity-result">{{testResultServer}}</span>
          </div>

          <div class="server-test-connectivity-button-container">

            <ac-button  (click)="testServerConnectivity()"  buttonId="test-connectivity"
                    [ngDisabled]="!ldapAuthentication.host || !ldapAuthentication.port">Test</ac-button>
          </div>

          <arm-form-title>SSL Configuration</arm-form-title>
          <div class="settings-section">

            <mat-slide-toggle color="primary"
                              [checked]="ldapAuthentication.isSSL"
                              (change)="ldapAuthentication.isSSL = $event.checked">
              SSL
            </mat-slide-toggle>

            <ac-input-container label="Certificate File">
              <ac-file-picker alternativeName="ldapAuthentication.certificate"
                              (acChanged)="onFileChange($event)"
                              [ngDisabled]="!ldapAuthentication.isSSL"
                              [filePickerButtonText]="'Browse'">
              </ac-file-picker>
            </ac-input-container>

            <div class="ldap-certificate-wrapper" *ngIf="showCertificate">
              <mat-label><strong>Subject:</strong> {{ldapAuthentication.parsedCertificate.subject}}</mat-label>
              <mat-label><strong>Issuer:</strong> {{ldapAuthentication.parsedCertificate.issuer}}</mat-label>
              <mat-label><strong>Not before:</strong> {{ldapAuthentication.parsedCertificate.notBefore | date:'yyyy-MM-dd HH:mm:ss Z'}}</mat-label>
              <mat-label><strong>Not after:</strong> {{ldapAuthentication.parsedCertificate.notAfter | date:'yyyy-MM-dd HH:mm:ss Z'}}</mat-label>
              <mat-label><strong>Validity:</strong> {{ldapAuthentication.parsedCertificate.validity}}</mat-label>
            </div>
          </div>
        </div>
      </div>

      <div class="form-table-column">
        <arm-form-title>Authorization level settings</arm-form-title>
        <div class="settings-section">
          <div class="server-level">
            <mat-radio-group [(ngModel)]="ldapAuthentication.mappings.doUseGroupMembership" [ngModelOptions]="{standalone: true}">
              <mat-radio-button class="membership-radio-button" color="primary"
                                *ngFor="let membershipOption of doUseGroupMembershipOptions" [value]="membershipOption.value">
                {{membershipOption.text}}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <ng-container *ngIf="!ldapAuthentication.mappings.doUseGroupMembership">

            <mat-form-field class="fullWidth">
              <mat-label>User Name Attribute</mat-label>
              <input [(ngModel)]="ldapAuthentication.mappings.userNameAttribute" matInput name="user-name-attr" [required]="ldapAuthentication.isEnabled">
            </mat-form-field>

            <mat-form-field class="fullWidth">
              <mat-label>Permissions Attribute</mat-label>
              <input [(ngModel)]="ldapAuthentication.mappings.permissionsAttribute" matInput name="permission-attr" [required]="ldapAuthentication.isEnabled">
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="ldapAuthentication.mappings.doUseGroupMembership">
            <mat-form-field class="fullWidth">
              <mat-label>User Name Attribute</mat-label>
              <input [(ngModel)]="ldapAuthentication.mappings.groupMembershipUserNameAttribute" matInput name="grp-user-name-attr" [required]="ldapAuthentication.isEnabled">
            </mat-form-field>

            <mat-form-field class="fullWidth">
              <mat-label>Group Membership Attribute</mat-label>
              <input [(ngModel)]="ldapAuthentication.mappings.groupMembershipAttribute" matInput name="grp-permission-attr" [required]="ldapAuthentication.isEnabled">
            </mat-form-field>

            <mat-form-field class="fullWidth">
              <mat-label>Group Name Attribute</mat-label>
              <input [(ngModel)]="ldapAuthentication.mappings.groupNameAttribute" matInput name="group-name-attr">
            </mat-form-field>

            <mat-form-field class="fullWidth">
              <mat-label>Group ObjectClass Attribute</mat-label>
              <input [(ngModel)]="ldapAuthentication.mappings.groupObjectClassAttribute" matInput name="group-object-class-attr">
            </mat-form-field>
          </ng-container>
        </div>
        <arm-form-title>Test Connectivity</arm-form-title>
        <div class="settings-section">
          <mat-form-field class="fullWidth">
            <mat-label>Name</mat-label>
            <input [(ngModel)]="ldapAuthentication.testConnectivity.name" matInput name="test-connectivity-name">
          </mat-form-field>

          <mat-form-field class="fullWidth">
            <mat-label>Password</mat-label>
            <input type="password" [(ngModel)]="ldapAuthentication.testConnectivity.password" matInput name="test-connectivity-password">
          </mat-form-field>

          <div class="test-connectivity-result-wrapper" [ngClass]="{'green': testResult === 'Ldap server connection test successful'}">
            <mat-label class="test-connectivity-result">{{testResult}}</mat-label>
          </div>

          <div class="test-connectivity-button-container" >
            <ac-button  [ngDisabled]="!ldapAuthentication.testConnectivity.password || !ldapAuthentication.testConnectivity.name"
                    buttonId="test-connectivity-user" (click)="testConnectivity()">Test</ac-button>
          </div>
        </div>
      </div>
      <div class="form-table-column">
        <arm-form-title>Advanced LDAP settings</arm-form-title>
        <div class="settings-section">
          <mat-slide-toggle color="primary"
                            [checked]="ldapAuthentication.isReferralEnabled"
                            (change)="ldapAuthentication.isReferralEnabled = $event.checked">
            Enable Referrals
          </mat-slide-toggle>
        </div>

        <arm-form-title>Authentication Mode</arm-form-title>
        <div class="settings-section">
          <ac-input-container label="Authentication Order:">
            <ac-select [acModel]="ldapAuthentication.isLocalFirst"
                       [searchable]="false"
                       (acModelChange)="ldapAuthentication.isLocalFirst = $event"
                       [items]="authenticationOrderList"
                       bindLabel="description"
                       bindValue="bool">
            </ac-select>
          </ac-input-container>
        </div>

      </div>
    </div>
  </arm-form>
</div>
